import QuickTextTemplateModal from "components/pages/quickTaskTemplates/modals/QuickTextTemplateModal";
import QuickTextTemplateTable from "components/pages/quickTaskTemplates/table/QuickTextTemplateTable";
import QuickTextTemplateConfirmModal from "components/pages/quickTaskTemplates/modals/QuickTextTemplateConfirmModal";
import { useSelector } from "react-redux";

const QuickTextTemplates = () => {
  const { showModal, showConfirmModal } = useSelector(
    (state) => state.quickTextTemplate
  );

  return (
    <>
      <div style={{ position: "relative" }}>
        {showModal && <QuickTextTemplateModal />}
        {showConfirmModal && <QuickTextTemplateConfirmModal />}
        <QuickTextTemplateTable />
      </div>
    </>
  );
};

export default QuickTextTemplates;
